import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Utils } from 'src/app/utils/utils';

@Component({
  selector: 'app-consulta-dados-estaduais',
  templateUrl: './consulta-dados-estaduais.component.html',
  styleUrls: ['./consulta-dados-estaduais.component.scss']
})
export class ConsultaDadosEstaduaisComponent implements OnInit, OnChanges {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  alienacao: String;
  arrendamento: String;
  restricaoAdministrativa: String;
  restricaoJudicial: String;
  restricaoJudicialOK: String;
  reservaDominio: String;
  rouboFurto: String;
  reserva: String;
  restricaoTributaria: String;
  sinistroRecuperado: String;
  observacoes: String;
  observacoesOK: String;
  possuiRouboFurtoEstadual: boolean;
  tipoMontagem : String;
  tipoDocComprador: string;
  showGravame: boolean;
  showIntencaoGravame: boolean;
  dadosComunicacaoVenda = false;
  vistorias: any[] = [];
  showVistorias = false;

  @Input() token = '';

  ocorrenciaIpva: boolean = false;
  ocorrenciaMultas: boolean = false;
  ocorrenciaDpvat: boolean = false;
  ocorrenciaLicenciamento: boolean = false;

  constructor() {}

  ngOnInit() {
  }

  ngOnChanges() {
    this.inicializarVariaveis();
    this.verificaOcorrenciaIpva();
    this.getRestricoes();
    this.getSituacaoRouboFurtoEstadual();
    this.getTipoDocComprador();
    this.getTipoMontagem();
    this.verificaComunicacaoVenda();
    this.getGravame();
    this.getIntencaoGravame();
    this.getVistorias();
  }

  getVistorias() {
    this.vistorias = (this.consulta && this.consulta.vistorias) ? this.consulta.vistorias : [];
    this.showVistorias = this.vistorias.length > 0;
  }

  inicializarVariaveis(){
    this.ocorrenciaIpva = false;
    this.ocorrenciaMultas = false;
    this.ocorrenciaDpvat= false;
    this.ocorrenciaLicenciamento = false;
  }

  verificaOcorrenciaIpva() {
    if(this.consulta?.ocorrenciasDebEstadual != null && this.consulta?.ocorrenciasDebEstadual.length > 0)
      this.consulta?.ocorrenciasDebEstadual.forEach(ocorrencia => {
        if(ocorrencia == 'IPVA')
          this.ocorrenciaIpva = true;
        else if(ocorrencia == 'MULTAS')
          this.ocorrenciaMultas = true;
        else if(ocorrencia == 'DPVAT')
          this.ocorrenciaDpvat = true;
        else if(ocorrencia == 'LICENCIAMENTO')
          this.ocorrenciaLicenciamento = true;
      });
  }

  reciverReload(binestadual) {
    this.consulta = binestadual;
  }

  getTipoDocComprador() {
    if (this.consulta != null) {
      if (this.consulta.cpfCnpjProprietario != null && this.consulta.cpfCnpjProprietario != "")
        if (this.consulta.cpfCnpjProprietario.length < 14) {
          this.tipoDocComprador = 'CPF';
        } else {
          this.tipoDocComprador = 'CNPJ';
        }
    }
  }

  getTipoMontagem(){
    if( this.consulta )
      this.tipoMontagem = (this.consulta.tipo=='REBOQUE'||this.consulta.tipo=='SEMI_REBOQUE')?'INCOMPLETA':'COMPLETA'
  }

  getGravame(){
    if( this.consulta ){
      this.showGravame = this.consulta.nomeAgenteFinanceiro || this.consulta.nomeFinanciado || this.consulta.dataInclusaoFinanc ||
          this.consulta.tipoRestricaoFinanceira || this.consulta.cpfCnpjFinanciado;
    }
  }

  getIntencaoGravame(){
    if( this.consulta ){
      this.showIntencaoGravame = this.consulta.nomeAgenteFinanceiroIntencaoGravame || this.consulta.cpfCnpjFinanciadoIntencaoGravame || this.consulta.dataInclusaoIntencaoGravame ||
          this.consulta.nomeFinanciadoIntencaoGravame || this.consulta.restricaoFinanceiraIntencaoGravame;
    }
  }

  getSituacaoRouboFurtoEstadual() {
    this.possuiRouboFurtoEstadual = false;
    if (this.consulta != null && this.consulta.lista != null) {
      for (let i = 0; i < this.consulta.lista.length; i++) {
        if (this.consulta.lista[i].descricao != null) {
          if (this.consulta.lista[i].descricao.toUpperCase() == "ROUBO FURTO") {
            this.possuiRouboFurtoEstadual = true;
          }
          if (this.consulta.lista[i].descricao.toUpperCase() == "ROUBO E FURTO ATIVO") {
            this.possuiRouboFurtoEstadual = true;
          }
          if (this.consulta.lista[i].descricao.toUpperCase() == "VEICULO COM OCORRENCIA DE FURTO/ROUBO") {
            this.possuiRouboFurtoEstadual = true;
          }
          if (this.consulta.lista[i].descricao.toUpperCase().includes("OCORRENCIA DE ROUBO")) {
            this.possuiRouboFurtoEstadual = true;
          }
          if (this.consulta.lista[i].descricao.toUpperCase() == "RESTRICAO OCORRENCIA ROUBO FURTO") {
            this.possuiRouboFurtoEstadual = true;
          }
        }
      }
    }
  }

  getRestricoes() {
    if (this.consulta && this.consulta.lista && this.consulta.lista.length > 0) {
      for (let i = 0; i < this.consulta.lista.length; i++) {
        if (this.consulta.lista[i].descricao != null) {
          if (this.consulta.lista[i].descricao.toUpperCase().indexOf("ADMINISTRATIVA") != -1) {
            this.restricaoAdministrativa = this.consulta.lista[i].descricao;
          }else if (this.consulta.lista[i].descricao.toUpperCase().indexOf("ALIENAÇÃO") != -1 || this.consulta.lista[i].descricao.toUpperCase().indexOf("ALIENACAO") != -1) {
            this.alienacao = this.consulta.lista[i].descricao;
          }else if (this.consulta.lista[i].descricao.toUpperCase().indexOf("ARRENDAMENTO") != -1) {
            this.arrendamento = this.consulta.lista[i].descricao;
          }else if (this.consulta.lista[i].descricao.toUpperCase().indexOf("JUDICIAL") != -1) {

            if(this.consulta.lista[i].descricao === "NÃO CONSTA BLOQUEIO JUDICIAL - RENAJUD"){
              this.restricaoJudicialOK = this.consulta.lista[i].descricao;
            } else {
              this.restricaoJudicial = this.consulta.lista[i].descricao;
            }

          }else if (this.consulta.lista[i].descricao.toUpperCase().includes("DOM")) {
            this.reservaDominio = this.consulta.lista[i].descricao;
          }else if ((this.consulta.lista[i].descricao.toUpperCase().indexOf("ROUBO FURTO") != -1)
            || (this.consulta.lista[i].descricao.toUpperCase().indexOf("ROUBO E FURTO") != -1)
            || (this.consulta.lista[i].descricao.toUpperCase().indexOf("VEICULO COM OCORRENCIA DE FURTO/ROUBO") != -1)
            || (this.consulta.lista[i].descricao.toUpperCase().includes("OCORRENCIA DE ROUBO"))
          ) {
            this.rouboFurto = this.consulta.lista[i].descricao;
          }else if (this.consulta.lista[i].descricao.toUpperCase().indexOf("TRIBUTARI") != -1 || this.consulta.lista[i].descricao.toUpperCase().indexOf("TRIBUTÁRI") != -1) {
            this.restricaoTributaria = this.consulta.lista[i].descricao;
          }else if (this.consulta.lista[i].descricao.toUpperCase().indexOf("SINISTRO RECUPERADO") != -1) {
            this.sinistroRecuperado = this.consulta.lista[i].descricao;
          }else {
            if(this.consulta.lista[i].descricao === "VEÍCULO COM INSPEÇÃO VEICULAR 'OK'"){
              this.observacoesOK = this.consulta.lista[i].descricao;
            } else {
              /* 
                Caso não tenha sido definida nenhuma observação, inicializar a string.
                Caso já tenha sido definida, concatenar com ';' + nova observação.  
              */
              if (!this.observacoes) {
                this.observacoes = this.consulta.lista[i].descricao;
              } else {
                this.observacoes = this.observacoes + ';' + this.consulta.lista[i].descricao;
              }
            }

          }

        }
      }

    }

  }

  verificaComunicacaoVenda() {
    this.consulta.dataVenda ? this.dadosComunicacaoVenda = true : false;
    this.consulta.dataInclusaoVenda ? this.dadosComunicacaoVenda = true : false;
    this.consulta.anoExercicioLicenciamento ? this.dadosComunicacaoVenda = true : false;
    this.consulta.indicadorComunicaVenda ? this.dadosComunicacaoVenda = true : false;
  }

  isNumber(value: any): boolean {
    return !isNaN( Utils.stringToNumber(value) );
  }

}
